import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdateMainPageGroup = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncUpdateMainPageGroup, isPending } = useMutation('updateMainPageGroup', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['main-page-group'] });
      toast.success(res.message);
      await revalidate(['all']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncUpdateMainPageGroup, isPending };
};

export default useUpdateMainPageGroup;
